<template>
    <div class="policy-wrapper p-4 md:p-6 surface-card border-round-xl shadow-1 text-left">
        <div class="mb-5">
            <p class="text-900 mb-2">Version: 1.0</p>
            <p class="text-900 mb-2">Jurisdiction: Democratic Socialist Republic of Sri Lanka</p>
        </div>

        <div class="policy-section mb-5">
            <h2 class="H5-SemiBold text-primary mb-3">1. PURPOSE OF THIS POLICY</h2>
            <p class="text-body mb-2">1.1 ILearn’d Tutors is committed to maintaining a <b>safe, respectful, and protected learning environment</b> for all children. This Child Protection & Safeguarding Policy establishes mandatory standards, responsibilities, and procedures to prevent abuse, exploitation, grooming, and harm to minors using the Platform.</p>
            <p class="text-body mb-2">The objectives of this Policy are to:</p>
            <p class="text-body ml-3 mb-1">protect children from abuse, exploitation, neglect, and harm;</p>
            <p class="text-body ml-3 mb-1">define clear behavioural expectations for all users;</p>
            <p class="text-body ml-3 mb-1">ensure compliance with Sri Lankan child protection laws;</p>
            <p class="text-body ml-3 mb-1">provide clear reporting and emergency escalation procedures; and</p>
            <p class="text-body ml-3">enable prompt cooperation with law enforcement and child protection authorities.</p>
        </div>

        <div class="policy-section mb-5">
            <h2 class="H5-SemiBold text-primary mb-3">2. SCOPE OF APPLICATION</h2>
            <p class="text-body mb-2">2.1 This Policy applies to:</p>
            <p class="text-body ml-3 mb-1">students;</p>
            <p class="text-body ml-3 mb-1">tutors;</p>
            <p class="text-body ml-3 mb-1">parents and legal guardians;</p>
            <p class="text-body ml-3 mb-1">institutes;</p>
            <p class="text-body ml-3 mb-1">general users; and</p>
            <p class="text-body ml-3 mb-2">ILearn’d Tutors staff and contractors.</p>
            <p class="text-body mb-2">2.2 This Policy applies to <b>all interactions involving minors conducted through the Platform.</b></p>
            <p class="text-body mb-1">2.3 Important:</p>
            <p class="text-body ml-3 mb-1">All tutoring sessions on the Platform are conducted <b>exclusively online.</b></p>
            <p class="text-body ml-3"><b>In-home, tutor-residence, or physical sessions are not permitted under any circumstances.</b></p>
        </div>

        <div class="policy-section mb-5">
            <h2 class="H5-SemiBold text-primary mb-3">3. DEFINITIONS</h2>
            <p class="text-body mb-1"><b>Child / Minor:</b> Any individual under eighteen (18) years of age.</p>
            <p class="text-body mb-1"><b>Safeguarding:</b> Measures taken to protect children from harm, abuse, or exploitation.</p>
            <p class="text-body mb-1"><b>Child Abuse:</b> Physical, emotional, psychological, or sexual harm to a child.</p>
            <p class="text-body mb-1"><b>Neglect:</b> Failure to provide adequate care, supervision, or protection.</p>
            <p class="text-body"><b>Grooming:</b> Any behaviour intended to establish an inappropriate or exploitative relationship with a minor.</p>
        </div>

        <div class="policy-section mb-5">
            <h2 class="H5-SemiBold text-primary mb-3">4. ZERO-TOLERANCE POLICY</h2>
            <p class="text-body mb-2">4.1 ILearn’d Tutors enforces a <b>strict zero-tolerance policy</b> towards:</p>
            <p class="text-body ml-3 mb-1">physical, emotional, or psychological harm;</p>
            <p class="text-body ml-3 mb-1">sexual abuse, harassment, or inappropriate remarks;</p>
            <p class="text-body ml-3 mb-1">grooming behaviour;</p>
            <p class="text-body ml-3 mb-1">bullying, intimidation, or discrimination;</p>
            <p class="text-body ml-3 mb-1">solicitation of personal information or images;</p>
            <p class="text-body ml-3 mb-1">sharing personal contact details with minors;</p>
            <p class="text-body ml-3 mb-1">off-platform communication with minors; and</p>
            <p class="text-body ml-3 mb-2">any attempt to arrange offline or private meetings.</p>
            <p class="text-body mb-2">4.2 Any violation may result in:</p>
            <p class="text-body ml-3 mb-1">immediate account suspension;</p>
            <p class="text-body ml-3 mb-1">permanent account termination;</p>
            <p class="text-body ml-3 mb-1">reporting to the Sri Lanka Police and/or the National Child Protection Authority (NCPA); and</p>
            <p class="text-body ml-3">legal action under applicable Sri Lankan law.</p>
        </div>

        <div class="policy-section mb-5">
            <h2 class="H5-SemiBold text-primary mb-3">5. ROLES & RESPONSIBILITIES</h2>
            <p class="text-body font-bold mb-1">5.1 Tutors</p>
            <p class="text-body mb-2">Tutors must:</p>
            <p class="text-body ml-3 mb-1">5.1.1 maintain professional boundaries at all times;</p>
            <p class="text-body ml-3 mb-1">5.1.2 communicate <b>only through Platform-approved tools;</b></p>
            <p class="text-body ml-3 mb-1">5.1.3 refrain from requesting personal contact details or images;</p>
            <p class="text-body ml-3 mb-1">5.1.4 conduct sessions in a visible, appropriate online environment;</p>
            <p class="text-body ml-3 mb-1">5.1.5 report safeguarding concerns <b>as soon as reasonably practicable,</b> and in any event within twenty-four (24) hours; and</p>
            <p class="text-body ml-3 mb-3">5.1.6 comply with all child protection laws and Platform policies.</p>

            <p class="text-body font-bold mb-1">5.2 Parents / Guardians</p>
            <p class="text-body mb-2">Parents or guardians must:</p>
            <p class="text-body ml-3 mb-1">5.2.1 provide verifiable consent for minors;</p>
            <p class="text-body ml-3 mb-1">5.2.2 supervise online sessions for children under sixteen (16);</p>
            <p class="text-body ml-3 mb-1">5.2.3 ensure a safe environment during sessions;</p>
            <p class="text-body ml-3 mb-1">5.2.4 provide accurate emergency contact details; and</p>
            <p class="text-body ml-3 mb-3">5.2.5 report concerns immediately.</p>

            <p class="text-body font-bold mb-1">5.3 Students</p>
            <p class="text-body mb-2">Students must:</p>
            <p class="text-body ml-3 mb-1">5.3.1 use Platform communication tools only;</p>
            <p class="text-body ml-3 mb-1">5.3.2 avoid sharing personal information; and</p>
            <p class="text-body ml-3 mb-3">5.3.3 report any behaviour that feels unsafe or inappropriate.</p>

            <p class="text-body font-bold mb-1">5.4 Institutes</p>
            <p class="text-body mb-2">Institutes must:</p>
            <p class="text-body ml-3 mb-1">5.4.1 verify tutors operating under their profile;</p>
            <p class="text-body ml-3 mb-1">5.4.2 ensure safeguarding compliance; and</p>
            <p class="text-body ml-3 mb-3">5.4.3 cooperate fully with audits and investigations.</p>

            <p class="text-body font-bold mb-1">5.5 ILearn’d Tutors</p>
            <p class="text-body mb-2">ILearn’d Tutors will:</p>
            <p class="text-body ml-3 mb-1">5.5.1 implement identity and document verification where applicable;</p>
            <p class="text-body ml-3 mb-1">5.5.2 provide secure reporting and SOS tools;</p>
            <p class="text-body ml-3 mb-1">5.5.3 maintain incident records;</p>
            <p class="text-body ml-3 mb-1">5.5.4 investigate reports promptly; and</p>
            <p class="text-body ml-3">5.5.5 cooperate fully with law enforcement and child protection authorities.</p>
        </div>

        <div class="policy-section mb-5">
            <h2 class="H5-SemiBold text-primary mb-3">6. SAFEGUARDING RULES FOR ONLINE SESSIONS</h2>
            <p class="text-body mb-2">6.1 Sessions must be conducted using <b>Platform-approved video tools only.</b></p>
            <p class="text-body mb-2">6.2 Tutors must maintain a professional environment and conduct.</p>
            <p class="text-body mb-2">6.3 Recording of sessions is prohibited unless <b>explicit consent</b> is obtained from all parties and permitted by Platform rules.</p>
            <p class="text-body mb-2">6.4 Private chats unrelated to instruction are prohibited.</p>
            <p class="text-body">6.5 AI-assisted tools used within tutoring sessions operate solely for educational summarisation and organisational purposes and are subject to the same safeguarding and monitoring standards applicable to other Platform communication tools.</p>
        </div>

        <div class="policy-section mb-5">
            <h2 class="H5-SemiBold text-primary mb-3">7. PROHIBITED BEHAVIOUR</h2>
            <p class="text-body mb-2">The following conduct is strictly forbidden:</p>
            <p class="text-body ml-3 mb-1">7.1 sexual, romantic, or suggestive communication;</p>
            <p class="text-body ml-3 mb-1">7.2 sharing personal contact details;</p>
            <p class="text-body ml-3 mb-1">7.3 requesting or sending images;</p>
            <p class="text-body ml-3 mb-1">7.4 encouraging secrecy;</p>
            <p class="text-body ml-3 mb-1">7.5 harassment, bullying, or coercion;</p>
            <p class="text-body ml-3 mb-1">7.6 impersonation or false identity use; and</p>
            <p class="text-body ml-3">7.7 misuse of Platform tools to evade safeguards.</p>
        </div>

        <div class="policy-section mb-5">
            <h2 class="H5-SemiBold text-primary mb-3">8. REPORTING MECHANISMS</h2>
            <p class="text-body mb-2"><b>8.1 SOS Emergency System:</b> The SOS feature may be used in cases of immediate risk, threats, or inappropriate conduct.</p>
            <p class="text-body mb-2"><b>8.2 Online Reporting:</b> Reports may be submitted via the Platform’s reporting tools.</p>
            <p class="text-body"><b>8.3 Mandatory Reporting:</b> Tutors, parents, and institutes must report suspected abuse, grooming, exploitation, or endangerment <b>without delay.</b></p>
        </div>

        <div class="policy-section mb-5">
            <h2 class="H5-SemiBold text-primary mb-3">9. LAW ENFORCEMENT ESCALATION</h2>
            <p class="text-body mb-3">ILearn’d Tutors will escalate suspected criminal activity involving minors to the <b>Sri Lanka Police,</b> the <b>National Child Protection Authority (NCPA),</b> or any other competent authority.</p>
            
            <p class="text-body font-bold mb-1">9.1 Information Disclosure</p>
            <p class="text-body mb-2">Where required to protect a child, ILearn’d Tutors may disclose:</p>
            <p class="text-body ml-3 mb-1">identity and verification data;</p>
            <p class="text-body ml-3 mb-1">communication logs;</p>
            <p class="text-body ml-3 mb-1">session records;</p>
            <p class="text-body ml-3 mb-1">IP addresses and login history; and</p>
            <p class="text-body ml-3 mb-2">internal investigation findings.</p>
            <p class="text-body">Such disclosure shall be made in compliance with applicable law.</p>
        </div>

        <div class="policy-section mb-5">
            <h2 class="H5-SemiBold text-primary mb-3">10. INCIDENT RESPONSE PROCESS</h2>
            <p class="text-body ml-3 mb-1">10.1 receipt and logging of report;</p>
            <p class="text-body ml-3 mb-1">10.2 immediate risk assessment;</p>
            <p class="text-body ml-3 mb-1">10.3 temporary account suspension where necessary;</p>
            <p class="text-body ml-3 mb-1">10.4 parental notification where appropriate;</p>
            <p class="text-body ml-3 mb-1">10.5 internal investigation;</p>
            <p class="text-body ml-3 mb-1">10.6 escalation to authorities; and</p>
            <p class="text-body ml-3">10.7 implementation of further safeguards.</p>
        </div>

        <div class="policy-section mb-5">
            <h2 class="H5-SemiBold text-primary mb-3">11. DATA PRIVACY & RECORD KEEPING</h2>
            <p class="text-body mb-2">11.1 All data is processed in accordance with the <b>Personal Data Protection Act, No. 9 of 2022 of Sri Lanka (PDPA).</b></p>
            <p class="text-body mb-2">11.2 Incident records may be retained for up to <b>five (5) years,</b> or longer where legally required.</p>
            <p class="text-body">11.3 Access to safeguarding data is restricted to authorised personnel only.</p>
        </div>

        <div class="policy-section mb-5">
            <h2 class="H5-SemiBold text-primary mb-3">12. TRAINING & AWARENESS</h2>
            <p class="text-body mb-2">ILearn’d Tutors may provide:</p>
            <p class="text-body ml-3 mb-1">safeguarding training for tutors;</p>
            <p class="text-body ml-3 mb-1">guidance materials for parents;</p>
            <p class="text-body ml-3 mb-1">verification standards for institutes; and</p>
            <p class="text-body ml-3">periodic safety audits.</p>
        </div>

        <div class="policy-section mb-5">
            <h2 class="H5-SemiBold text-primary mb-3">13. NON-COMPLIANCE & PENALTIES</h2>
            <p class="text-body mb-2">Violation of this Policy may result in:</p>
            <p class="text-body ml-3 mb-1">suspension or termination of accounts;</p>
            <p class="text-body ml-3 mb-1">reporting to authorities;</p>
            <p class="text-body ml-3 mb-1">legal action; and</p>
            <p class="text-body ml-3">termination of institute partnerships.</p>
        </div>

        <div class="policy-section mb-5">
            <h2 class="H5-SemiBold text-primary mb-3">14. GOVERNING LAW</h2>
            <p class="text-body">14.1 This Policy shall be governed by the laws of the <b>Democratic Socialist Republic of Sri Lanka.</b></p>
        </div>

        <div class="policy-section mb-5">
            <h2 class="H5-SemiBold text-primary mb-3">15. AMENDMENTS</h2>
            <p class="text-body mb-2">Material amendments to this Policy shall be:</p>
            <p class="text-body ml-3 mb-1">15.1 communicated through the Platform; and</p>
            <p class="text-body ml-3">15.2 subject to <b>explicit consent</b>, where required by law, particularly where minors are affected.</p>
        </div>

        <div class="policy-section">
            <h2 class="H5-SemiBold text-primary mb-3">16. CONTACT INFORMATION</h2>
            <div class="p-3 border-round bg-faded">
                <p class="text-body font-bold mb-1"><b>ILearn’d Tutors – Legal Team</b></p>
                <p class="text-body mb-1">Email: support@ilearndsl.com</p>
                <p class="text-body mb-0">Address: 306/1 Highlevel Road, Colombo 06, Sri Lanka</p>
            </div>
        </div>
    </div>
</template>

<style scoped>
.text-primary { color: #1D97BD !important; }
.bg-faded { background-color: rgba(29, 151, 189, 0.04); }
.text-body {
    font-size: 0.95rem;
    color: #4A5568;
    font-weight: 400;
    line-height: 1.6;
}
.ml-3 { margin-left: 1.5rem; }
</style>